(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cocomii-performance-global"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /* The wallet layout script that sat here is retired (2026-11-03, owner: "Every time I open cart drawer, paypal and
       google pay buttons still shakes", "Sometimes google pay button disappears"). On every re-render of Shopify's
       wallet component it zeroed the buttons' margins and set font-size and line-height 0 on PayPal and Google Pay, then
       two frames later moved them to force 3 px gaps: measured on live, Shop Pay grew 44 to 48 px and PayPal and Google
       Pay jumped 3 and 2 px within 34 ms. The stack is set by Shopify's documented hooks instead (block-size 44 px in
       layout/theme.liquid, row-gap 4 px in the makeover CSS, Round 23c). */

    /* Hover-intent prefetch of internal links (replaces tiny-img-link-preloader) */
    (function () {
      if (navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType || ''))) return;
      var prefetched = Object.create(null);
      var hoverTimer = null;
      var supportsSpeculation = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

      function eligible(anchor) {
        if (!anchor || !anchor.href) return null;
        if (anchor.origin !== location.origin) return null;
        if (anchor.hasAttribute('download') || anchor.target === '_blank') return null;
        var path = anchor.pathname;
        if (path === location.pathname) return null;
        if (/^\/(cart|checkout|account|admin|challenge)/.test(path)) return null;
        if (/\.(jpg|jpeg|png|gif|webp|svg|pdf|zip|mp4|webm)$/i.test(path)) return null;
        var url = anchor.href.split('#')[0];
        if (prefetched[url]) return null;
        return url;
      }

      function prefetch(url) {
        prefetched[url] = true;
        if (supportsSpeculation) {
          var script = document.createElement('script');
          script.type = 'speculationrules';
          script.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url] }] });
          document.head.appendChild(script);
        } else {
          var link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = url;
          link.as = 'document';
          document.head.appendChild(link);
        }
      }

      document.addEventListener('mouseover', function (event) {
        var anchor = event.target.closest && event.target.closest('a[href]');
        var url = eligible(anchor);
        if (!url) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { prefetch(url); }, 65);
      }, { passive: true });

      document.addEventListener('mouseout', function () {
        clearTimeout(hoverTimer);
      }, { passive: true });

      document.addEventListener('touchstart', function (event) {
        var anchor = event.target.closest && event.target.closest('a[href]');
        var url = eligible(anchor);
        if (url) prefetch(url);
      }, { passive: true });
    })();
  })();

  /* Keep the space reserved for the fixed announcement bar equal to the bar's
     actual height. theme.css hardcodes 38px, which is wrong by whatever the bar
     really measures on a given device, and the difference shows as a white strip
     under it. Paired with the --cocomii-announcement-h rule in the stylesheet. */
  (function () {
    var root = document.documentElement;

    function sync() {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;
      var height = bar.getBoundingClientRect().height;
      if (height > 0) root.style.setProperty('--cocomii-announcement-h', height + 'px');
    }

    sync();
    document.addEventListener('DOMContentLoaded', sync);
    window.addEventListener('load', sync);
    window.addEventListener('orientationchange', function () { setTimeout(sync, 150); });
    // Web fonts land after first paint and change the bar's line box.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    // theme.liquid relocates the bar into the sticky wrapper, and the text is a
    // rotating slideshow, so watch the element rather than trusting one measure.
    if (window.ResizeObserver) {
      var observed = document.querySelector('.announcement-bar');
      if (observed) new ResizeObserver(sync).observe(observed);
    }
  })();

  /* Pin the mobile hero height to a plain pixel value.

     The heroes are sized in viewport units, so on a phone they track the URL
     bar: growing as it collapses on the way down, shrinking as it returns on
     the way up. svh is specified to be immune to exactly that, and on the
     owner's Chrome it was not, so this stops relying on viewport-unit semantics
     altogether and hands the stylesheet a fixed px value it cannot reinterpret.

     Measured once at load and then only when the WIDTH changes. A URL-bar
     collapse changes the height alone and is ignored, which is the whole point;
     rotation changes the width and is honoured. Above 768px the variable is
     removed so desktop falls back to the stylesheet's own value. */
  (function () {
    var root = document.documentElement;
    var lastWidth = window.innerWidth;

    function setHeroHeight() {
      if (window.innerWidth > 768) {
        root.style.removeProperty('--cocomii-hero-h');
        return;
      }
      root.style.setProperty('--cocomii-hero-h', Math.round(window.innerHeight * 0.9) + 'px');
    }

    setHeroHeight();
    document.addEventListener('DOMContentLoaded', setHeroHeight);

    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      setHeroHeight();
    });

    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        lastWidth = window.innerWidth;
        setHeroHeight();
      }, 200);
    });
  })();

  /* Put the hero poster behind the video so a loop wrap cannot flash the
     section's near-black background. See the .hero__media rule in the
     stylesheet for the sizing half of this. */
  (function () {
    function paintPoster() {
      var medias = document.querySelectorAll('.video-parent-section .hero__media');
      for (var i = 0; i < medias.length; i++) {
        var media = medias[i];
        if (media.style.backgroundImage) continue;
        var video = media.querySelector('video[poster]');
        if (!video) continue;
        // Read the attribute, not the property: the property resolves to an
        // absolute URL, which is fine, but an empty attribute yields the page
        // URL and would paint the document behind the video.
        var poster = video.getAttribute('poster');
        if (!poster) continue;
        media.style.backgroundImage = 'url("' + video.poster + '")';
      }
    }

    paintPoster();
    document.addEventListener('DOMContentLoaded', paintPoster);
    window.addEventListener('load', paintPoster);
  })();
/* Hover to open the CASES and DESIGNS megamenus.

     The theme binds this itself, but only as the LAST call in a single chained
     statement inside HeaderSection.init():

       this.initDrawers(), this.initDisclosures(), theme.headerNav.init(),
       theme.announcementBar.init(), this.hoverMenu()

     Because it is one comma expression, anything that throws earlier silently
     skips hoverMenu, and the menus fall back to native click-to-toggle. That is
     the reported symptom exactly, and it depends on which optional pieces load,
     which is why it appeared in one browser and not another.

     This binds hover independently so it cannot be skipped. It is idempotent:
     each details element is marked, so it never double-binds alongside the
     theme's own handler, and both handlers do the same thing anyway. Only the
     open/close behaviour is re-bound; the theme's click-to-navigate is left
     alone so nothing is duplicated there. */
  (function () {
    function bindHover() {
      var menus = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
      for (var i = 0; i < menus.length; i++) {
        var d = menus[i];
        if (d.dataset.cocomiiHoverBound === 'true') continue;
        d.dataset.cocomiiHoverBound = 'true';
        (function (detail) {
          detail.addEventListener('mouseover', function () {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
          detail.addEventListener('mouseleave', function () {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        })(d);
      }
    }

    bindHover();
    document.addEventListener('DOMContentLoaded', bindHover);
    window.addEventListener('load', bindHover);
    // The header re-renders in the theme editor and on some app injections.
    document.addEventListener('shopify:section:load', bindHover);
  })();
/* Notify Me on a sold out card.

     Submits through the real Liquid contact form in cocomii-notify-form.liquid.

     It used to fetch-POST /contact directly. That always failed: the store has
     Shopify's invisible hCaptcha on contact forms, which refuses a tokenless
     post with 400, and this handler treated any settled promise as success. So
     it showed "YOU ARE ON THE LIST" while discarding the address. Nothing was
     ever captured. Never report success the server did not confirm.

     It now adds the address to the subscribed list (form_type=customer) and
     tags it notify:<variantId>, rather than emailing the store. There is
     deliberately no per-variant alert queue: restocks are announced to the list.
     The tag keeps the demand data, so the list can be segmented by what people
     actually wanted and a real per-variant alert stays buildable later. */
  (function () {
    'use strict';

    function submitRequest(form, data) {
      var send = form.querySelector('button');
      var email = form.querySelector('input').value;
      // Hand off to the real Liquid form. It performs a native submit, so the
      // page navigates and the outcome is reported on the way back from the
      // server rather than guessed at here.
      if (typeof window.cocomiiNotifySubmit !== 'function') {
        form.innerHTML = '<span class="cocomii-notify__done">Please try again</span>';
        return;
      }
      send.textContent = 'SENDING';
      send.disabled = true;
      if (!window.cocomiiNotifySubmit(email, data)) {
        send.textContent = 'NOTIFY ME';
        send.disabled = false;
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('.cocomii-notify');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var data = {
        title: btn.getAttribute('data-title') || '',
        colour: btn.getAttribute('data-colour') || '',
        model: btn.getAttribute('data-model') || '',
        variant: btn.getAttribute('data-variant') || ''
      };
      var form = document.createElement('form');
      form.className = 'cocomii-notify__form';
      form.setAttribute('novalidate', 'novalidate');
      // The aria-label used to read "Email me when this is back in stock".
      // Nothing sends a per-product alert, so that was a promise we do not keep.
      // The field joins the COCOMII list, where restocks are announced, and the
      // small print says exactly that before they submit.
      form.innerHTML =
        '<input type="email" required class="cocomii-notify__input" placeholder="Email address" aria-label="Email address to join the COCOMII list">' +
        '<button type="submit" class="quick-product__btn">NOTIFY ME</button>' +
        '<span class="cocomii-notify__fine">Joins the COCOMII list, where restocks are announced. Unsubscribe anytime.</span>';
      btn.parentNode.replaceChild(form, btn);
      form.addEventListener('click', function (ev) { ev.stopPropagation(); });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var input = form.querySelector('input');
        if (!input.value || input.value.indexOf('@') < 0) { input.focus(); return; }
        submitRequest(form, data);
      });
      form.querySelector('input').focus();
      // Focusing the visible input does not bind the hidden Liquid form, so ask
      // for it explicitly and give hCaptcha time to attach before they submit.
      if (typeof window.cocomiiNotifyPrepare === 'function') { window.cocomiiNotifyPrepare(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function () {
    function hydrate(video) {
      if (video.dataset.cocomiiHydrated === 'true') return;
      video.dataset.cocomiiHydrated = 'true';
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      if (reducedMotion || saveData) {
        video.controls = true;
        return;
      }

      var play = video.play();
      if (play !== undefined) {
        play.catch(function () {
          video.controls = true;
        });
      }
    }

    function init(root) {
      var videos = root.querySelectorAll('[data-cocomii-lazy-video]:not([data-cocomii-observed])');
      videos.forEach(function (video) {
        video.dataset.cocomiiObserved = 'true';
        if (!('IntersectionObserver' in window)) {
          hydrate(video);
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            hydrate(video);
          });
        }, { rootMargin: '300px 0px' });
        observer.observe(video);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      syncColorVideo();
    });

    /* ---- colourway video follows the colour picker -----------------------
       The block above is rendered server side for one variant. Without this,
       changing colour on the PDP left the previous colourway's video playing.
       We read the checked colour radio (authoritative, whatever caused the
       change) and reveal the slot whose data-cocomii-video-color matches. */

    function currentColor() {
      var input = document.querySelector('fieldset.variant-input-wrap[data-handle="color"] input:checked');
      if (!input) return '';
      return (input.value || input.getAttribute('data-color-name') || '').trim().toLowerCase();
    }

    function resume(video) {
      if (!video) return;
      if (video.dataset.cocomiiHydrated !== 'true') { hydrate(video); return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var play = video.play();
      if (play !== undefined) {
        play.then(function () {
          // playback took, so drop the fallback controls bar if a previous
          // attempt had been refused (backgrounded tab, for instance)
          video.controls = false;
        }).catch(function () {
          video.controls = true;
        });
      }
    }

    function syncColorVideo() {
      var slots = document.querySelectorAll('[data-cocomii-video-color]');
      if (!slots.length) return;
      var want = currentColor();
      var shown = null;
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var mine = (slot.getAttribute('data-cocomii-video-color') || '').trim().toLowerCase();
        if (!shown && want && mine === want) {
          shown = slot;
        } else {
          if (!slot.hidden) {
            slot.hidden = true;
            var paused = slot.querySelector('video');
            if (paused && !paused.paused) paused.pause();
          }
        }
      }
      if (shown && shown.hidden) shown.hidden = false;
      if (shown) resume(shown.querySelector('video'));
    }

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.type !== 'radio') return;
      if (!t.closest || !t.closest('fieldset.variant-input-wrap[data-handle="color"]')) return;
      syncColorVideo();
    });

    /* Belt and braces: the theme fires these when the variant changes for any
       other reason (deep link, model switch forcing a colour, back button). */
    document.addEventListener('variantChange', syncColorVideo);
    document.addEventListener('variant:change', syncColorVideo);

    /* Browsers refuse autoplay while the tab is backgrounded. Retry the active
       colourway once the shopper comes back to it. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') syncColorVideo();
    });
  })();

  /* ---- variant-first gallery (makeover rounds 5 to 7, owner 2026-10-30) ---------------------
     The page arrives with the selected variant's photos first (Liquid at the top of this file). When the shopper
     picks another colour OR another phone model, the same order is computed here from the numbers in
     script[data-cocomii-cf] and the variant's photo: slides and thumbnails are put in the new order and renumbered,
     then the theme's own slider is rebuilt through the product section instance. Rebuilding is required: the theme's
     slideshow keeps the thumbnails in the order they had when it started, and its slide lookups use data-index. The
     theme then moves to the variant's photo (now the first) by that data-index on its own variantImageChange. A
     change that keeps the same order (two models sharing one photo) rebuilds nothing. Zoom (Photoswipe) reads the
     slides in page order each time it opens, so it follows the new order by itself. */
  (function () {
    var cf = null;

    function read() {
      var tag = document.querySelector('script[data-cocomii-cf]');
      if (!tag) return null;
      var d;
      try { d = JSON.parse(tag.textContent); } catch (e) { return null; }
      if (!d || !d.ids || !d.starts || typeof d.first !== 'number') return null;
      d.gallery = tag.closest('[data-product-images]');
      d.slider = d.gallery && d.gallery.querySelector('[data-product-photos]');
      d.scroller = d.gallery && d.gallery.querySelector('.product__thumbs--scroller');
      // the product section this gallery belongs to: only ITS variant changes count (a quick view or a second product
      // section on the page has its own variant form)
      d.section = d.gallery && d.gallery.closest('[data-section-type="product"]');
      if (!d.slider || !d.scroller || !d.section) return null;
      d.ids = d.ids.map(String);
      // pair every slide with the media id of the thumbnail in the same place (both loops render one order)
      var slides = d.slider.querySelectorAll('.product-main-slide');
      var thumbs = d.scroller.querySelectorAll('.product__thumb-item');
      if (!slides.length || slides.length !== thumbs.length || slides.length !== d.ids.length) return null;
      for (var i = 0; i < slides.length; i++) {
        var a = thumbs[i].querySelector('[data-id]');
        if (!a) return null;
        slides[i].setAttribute('data-cocomii-cf-id', a.getAttribute('data-id'));
      }
      return d;
    }

    // the same swap as the Liquid: the variant's photo and the photos after it (up to the next photo a variant points
    // at, at most three) trade places with as many photos at the top
    function order(variant) {
      var ids = cf.ids.slice();
      var f = variant.featured_media ? ids.indexOf(String(variant.featured_media.id)) : -1;
      if (f > 0) {
        var e = ids.length;
        cf.starts.forEach(function (s) { if (s > f && s < e) e = s; });
        var k = Math.min(3, e - f, cf.first, f);
        for (var i = 0; i < k; i++) {
          var t = ids[i]; ids[i] = ids[f + i]; ids[f + i] = t;
        }
      }
      return ids;
    }

    function instance() {
      var list = window.theme && theme.sections && theme.sections.instances;
      if (!list) return null;
      for (var i = 0; i < list.length; i++) {
        var inst = list[i];
        if (inst && inst.cache && inst.cache.mainSlider === cf.slider && typeof inst.initProductSlider === 'function') return inst;
      }
      return null;
    }

    function apply(variant) {
      if (!cf || !variant || !variant.options) return;
      var inst = instance();
      if (!inst || !inst.settings) return;
      // every variant change counts (colour or model); nothing is rebuilt when the order would not change
      var want = order(variant);
      var thumbById = {}, slideById = {};
      Array.prototype.forEach.call(cf.scroller.querySelectorAll('.product__thumb-item'), function (t) {
        var a = t.querySelector('[data-id]');
        if (a) thumbById[a.getAttribute('data-id')] = t;
      });
      Array.prototype.forEach.call(cf.slider.querySelectorAll('.product-main-slide'), function (s) {
        slideById[s.getAttribute('data-cocomii-cf-id')] = s;
      });
      var have = Array.prototype.map.call(cf.scroller.querySelectorAll('.product__thumb-item [data-id]'), function (a) { return a.getAttribute('data-id'); });
      if (want.join() === have.join()) return;
      for (var w = 0; w < want.length; w++) { if (!thumbById[want[w]] || !slideById[want[w]]) return; }

      // take the slider down first, so the slides are direct children of the slider element again
      if (inst.flickity && typeof inst.flickity.destroy === 'function') inst.flickity.destroy();
      inst.flickity = null;
      var featured = variant.featured_media ? String(variant.featured_media.id) : null;
      var current = 0;
      want.forEach(function (id, i) {
        var s = slideById[id], t = thumbById[id], a = t.querySelector('[data-id]');
        cf.slider.appendChild(s);
        s.setAttribute('data-index', i);
        s.classList.toggle('starting-slide', id === featured);
        s.classList.toggle('secondary-slide', id !== featured);
        cf.scroller.appendChild(t);
        t.setAttribute('data-index', i);
        a.setAttribute('data-index', i);
        if (id === featured) current = i;
      });
      inst.settings.currentSlideIndex = current;
      inst.initProductSlider(variant);
      // the new slider starts on its first photo without a "change", so the thumbnail column would not scroll back to
      // the highlighted thumbnail nor update its arrows; slideChange does both (and the slide tabindex)
      if (inst.flickity && typeof inst.flickity.slideChange === 'function') inst.flickity.slideChange(current);
    }

    // theme.js fires variantChange on the product section only (it does not bubble), before variant:change on the
    // document and before it moves the slider to the variant's photo (variantImageChange), so the rebuilt slider is
    // the one it moves. Listening on the section keeps other product forms on the page (quick view) out.
    function start() {
      cf = read();
      if (cf && !cf.section.hasAttribute('data-cocomii-cf-bound')) {
        cf.section.setAttribute('data-cocomii-cf-bound', '');
        cf.section.addEventListener('variantChange', function (event) {
          apply(event.detail && event.detail.variant);
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
